import FilterButtonCategories from "./filter-button-categories";

export default (
  onFilterChanged: () => {},
  shouldRender: () => {},
  setButtonRender: (value: boolean) => {}
  ) => {
  const filterButtonWrapper = document.getElementById('js-filter-button-wrapp');
  const observer = new MutationObserver(mutationRecords => {
    const rerender = shouldRender();
    if(rerender) {
      mutationRecords[0].addedNodes.forEach((item) => new FilterButtonCategories(
        (item as HTMLButtonElement),
        onFilterChanged
      ));
      setButtonRender(false);
    }
  });
  observer.observe(filterButtonWrapper, {
    childList: true, // observe direct children
    subtree: true, // and lower descendants too
    characterDataOldValue: true // pass old data to callback
  });
}
